<app-details-loader
  [Height]="'100%'"
  [LoaderMarginTop]="'19%'"
  *ngIf="loadFlag || errorMsg"
  [errorMsg]="errorMsg"
></app-details-loader>

<ng-container *ngIf="!loadFlag && !errorMsg">
  <payarc-back-link label="Back to disputes" route="/disputes/dispute-list"></payarc-back-link>

  <payarc-page-header title="Disputes" subtitle="Disputes report details"></payarc-page-header>

  <div class="dd-hero">
    <div class="dd-hero__amount">{{dispute.primary_case?.data.case_amount ? ('-' + ((dispute.primary_case?.data.case_amount) | currency:'USD':'symbol': '1.2-2')) : '--'}}</div>
    <payarc-status-badge [status]="dispute.primary_case?.data.status || '--'" [variant]="statusVariant(dispute.primary_case?.data.status)"></payarc-status-badge>
  </div>

  <div class="dd-grid">
    <div class="dd-col">
      <payarc-section-card heading="Dispute details">
        <dl class="dd-facts">
          <div class="dd-facts__row">
            <dt>Chargeback date</dt>
            <dd>{{dispute.primary_case?.data.report_date ? (dispute.primary_case?.data.report_date | date : 'MM/dd/yyyy') : '--'}}</dd>
          </div>
          <div class="dd-facts__row">
            <dt>Transaction date</dt>
            <dd>{{dispute.primary_case?.data.transaction_date ? (dispute.primary_case?.data.transaction_date | date : 'MM/dd/yyyy') : '--'}}</dd>
          </div>
          <div class="dd-facts__row">
            <dt>Reason</dt>
            <dd>{{dispute.primary_case?.data.reason_desc ? dispute.primary_case?.data.reason_desc : '--'}}</dd>
          </div>
          <div class="dd-facts__row">
            <dt>Case type</dt>
            <dd>{{dispute.primary_case?.data.case_type ? ( dispute.primary_case?.data.case_type | camalizeStr : true) : '--'}}</dd>
          </div>
          <div class="dd-facts__row">
            <dt>Card</dt>
            <dd>
              <payarc-card-mark [width]="28" [brand]="dispute.primary_case?.data?.card_type"></payarc-card-mark>{{dispute.primary_case?.data.case_number ? dispute.primary_case?.data.card_number : '--'}}
            </dd>
          </div>
          <div class="dd-facts__row" *ngIf="dispute.primary_case?.data?.charge_id">
            <dt>Original payment</dt>
            <dd><a [routerLink]="'/payment/payment-details'" [queryParams]="{id: dispute.primary_case?.data?.charge_id}">View transaction &rsaquo;</a></dd>
          </div>
          <div class="dd-facts__row">
            <dt>View response</dt>
            <dd>
              <ng-container *ngIf="dispute.primary_case?.data?.evidence?.data.length !== 0; else noResponseDocs">
                <span class="dd-doc-item" *ngFor="let file of dispute.primary_case?.data?.evidence?.data; let i = index">
                  <button type="button" class="dd-doc-link" (click)="viewEvidence(file)">View document {{i + 1}}</button>
                  <button type="button" class="dd-comment-btn" *ngIf="file.text !== ''" (click)="showComment(file.text, i)" aria-label="View comment">
                    <i class="fa fa-comment" aria-hidden="true"></i>
                  </button>
                </span>
              </ng-container>
              <ng-template #noResponseDocs>--</ng-template>
            </dd>
          </div>
          <div class="dd-facts__row">
            <dt>Responded</dt>
            <dd *ngIf="dispute.primary_case?.data?.evidence?.data.length === 0">Not responded</dd>
            <dd *ngIf="dispute.primary_case?.data?.evidence?.data.length > 0">{{dispute.primary_case?.data?.evidence?.data[0].updated_at ? ((dispute.primary_case?.data?.evidence?.data[0].updated_at * 1000) | date : 'MM/dd/yyyy') : '--'}}</dd>
          </div>
          <div class="dd-facts__row">
            <dt>View chargeback</dt>
            <dd>
              <ng-container *ngIf="isPaypalCase(dispute.primary_case?.data); else primaryCaseFiles">
                <a *ngIf="dispute.primary_case?.data?.case_number" [href]="paypalCaseUrl(dispute.primary_case?.data)" target="_blank" rel="noopener noreferrer">View in PayPal Resolution Center</a>
                <ng-container *ngIf="!dispute.primary_case?.data?.case_number">--</ng-container>
              </ng-container>
              <ng-template #primaryCaseFiles>
                <ng-container *ngIf="dispute.primary_case?.data?.file?.data.length !== 0; else noChargebackFiles">
                  <button type="button" class="dd-doc-link" *ngFor="let file of dispute.primary_case?.data?.file?.data; let i = index" (click)="viewFile(file)">View document {{i + 1}}</button>
                </ng-container>
                <ng-template #noChargebackFiles>--</ng-template>
              </ng-template>
            </dd>
          </div>
        </dl>
      </payarc-section-card>

      <payarc-section-card heading="Related cases" *ngIf="dispute.related_cases?.data.length > 0">
        <mat-vertical-stepper #stepper>
          <ng-container *ngFor="let case of dispute.related_cases?.data; let i = index">
            <mat-step [completed]="case.id === primaryCaseId" *ngIf="i < 3">
              <ng-template matStepLabel><span>Chargeback: {{case.report_date | date : 'MM/dd/yyyy'}}</span></ng-template>

              <dl class="dd-facts">
                <div class="dd-facts__row">
                  <dt>Case no</dt>
                  <dd><button type="button" class="dd-case-link" [class.dd-case-link--primary]="case.id === primaryCaseId" (click)="switchCases(case)" [disabled]="isSubmitting">{{case.case_number ? case.case_number : '--'}}</button></dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Transaction date</dt>
                  <dd>{{ case.transaction_date ? (case.transaction_date | date : 'MM/dd/yyyy') : '--' }}</dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Responded</dt>
                  <dd *ngIf="case.evidence?.data.length === 0">Not responded</dd>
                  <dd *ngIf="case.evidence?.data.length > 0">{{case.evidence?.data[0].updated_at ? ((case.evidence?.data[0].updated_at * 1000) | date : 'MM/dd/yyyy') : '--'}}</dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Case type</dt>
                  <dd>{{case.case_type ? ( case.case_type | camalizeStr : true) : '--'}}</dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Status</dt>
                  <dd><payarc-status-badge [status]="case.status || '--'" [variant]="relatedCaseStatusVariant(case.status)"></payarc-status-badge></dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Card number</dt>
                  <dd><payarc-card-mark [width]="28" [brand]="case.card_type"></payarc-card-mark>{{case.card_number ? case.card_number : '--'}}</dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Reason</dt>
                  <dd>{{case.reason_desc ? case.reason_desc : '--' }}</dd>
                </div>
                <div class="dd-facts__row">
                  <dt>Amount</dt>
                  <dd>{{case.case_amount ? ('-' + ((case.case_amount) | currency:'USD':'symbol': '1.2-2')) : '--'}}</dd>
                </div>
                <div class="dd-facts__row">
                  <dt>View chargeback</dt>
                  <dd>
                    <ng-container *ngIf="isPaypalCase(case); else relatedCaseFiles">
                      <a *ngIf="case.case_number" [href]="paypalCaseUrl(case)" target="_blank" rel="noopener noreferrer">View in PayPal Resolution Center</a>
                      <ng-container *ngIf="!case.case_number">--</ng-container>
                    </ng-container>
                    <ng-template #relatedCaseFiles>
                      <ng-container *ngIf="case.file?.data.length !== 0; else noRelatedChargebackFiles">
                        <button type="button" class="dd-doc-link" *ngFor="let file of case.file?.data; let i = index" (click)="viewFile(file)">View document {{i + 1}}</button>
                      </ng-container>
                      <ng-template #noRelatedChargebackFiles>--</ng-template>
                    </ng-template>
                  </dd>
                </div>
                <div class="dd-facts__row">
                  <dt>View response</dt>
                  <dd>
                    <ng-container *ngIf="case.evidence?.data.length !== 0; else noRelatedResponseDocs">
                      <span class="dd-doc-item" *ngFor="let file of case.evidence?.data; let i = index">
                        <button type="button" class="dd-doc-link" (click)="viewEvidence(file)">View document {{i + 1}}</button>
                        <button type="button" class="dd-comment-btn" *ngIf="file.text !== ''" (click)="showComment(file.text, i)" aria-label="View comment">
                          <i class="fa fa-comment" aria-hidden="true"></i>
                        </button>
                      </span>
                    </ng-container>
                    <ng-template #noRelatedResponseDocs>--</ng-template>
                  </dd>
                </div>
              </dl>
            </mat-step>
          </ng-container>
          <ng-template matStepperIcon="edit">
            <mat-icon>local_parking</mat-icon>
          </ng-template>
        </mat-vertical-stepper>
      </payarc-section-card>
    </div>

    <div class="dd-col" *ngIf="!isPaypalCase(dispute.primary_case?.data)">
      <payarc-section-card heading="Respond to this dispute">
        <div class="response">{{response}}</div>

        <form #evidenceForm="ngForm">
          <ng-container *ngIf="topErrorMessage">
            <p class="dd-error" *ngFor="let obj of keys1">
              <ng-container *ngFor="let value of obj">{{value}}</ng-container>
            </p>
          </ng-container>

          <div class="dd-upload-row" *ngFor="let file of fileList; let i = index">
            <span class="dd-upload-row__label">Upload supporting document</span>
            <button type="button" payarcButton="secondary" (click)="openFilePicker(i)" [disabled]="isSubmitting">
              {{ fileList[i] === undefined ? 'Choose your file' : fileList[i].name }}
            </button>
            <input style="display: none;" type="file" multiple="false" [id]="i" (change)="addFile($event.target.files, i)" [disabled]="isSubmitting"/>
            <button type="button" class="dd-remove-btn" *ngIf="fileList[i] !== undefined" (click)="removeFiles(i)" [disabled]="isSubmitting" aria-label="Remove file">
              <i class="fa fa-times-circle" aria-hidden="true"></i>
            </button>
            <button type="button" payarcButton="ghost" (click)="addfilePicker()" [disabled]="fileList.length >= maxFiles || isSubmitting">
              Select another file
            </button>
          </div>

          <div class="dd-ff">
            <label for="disputeText">Comment</label>
            <textarea class="pa-input" id="disputeText" name="disputeText" #disputeText="ngModel" [(ngModel)]="uploadModel.text" [disabled]="isSubmitting"></textarea>
          </div>

          <button type="submit" payarcButton="primary" [disabled]="!evidenceForm.form.valid || isSubmitting" (click)="onSubmit()">Submit</button>
        </form>
      </payarc-section-card>
    </div>
  </div>
</ng-container>
